const appEnvironment = process.env.VITE_APP_ENV;

// used to show console logs on the frontend for local and dev environments, and not prod
export const isLocalOrDevEnvironment = () =>
  appEnvironment === "local" || appEnvironment === "dev";

export const getHostName = () => {
  if (appEnvironment === "local") {
    return "https://local.my-kaboodle.ai:8000";
  } else if (appEnvironment === "dev") {
    return "https://dev.my-kaboodle.ai";
  } else if (appEnvironment === "prod") {
    return "https://my-kaboodle.ai";
  }
  throw new Error(`Unknown VITE_APP_ENV: ${appEnvironment}`);
};
